// extracted by mini-css-extract-plugin
module.exports = {"ameriaComponent":"_2CTSfjnc5cvObzR3-Zu1br","ameriaImg":"WrGyAjFBvbN5_KEVO20KU"};